<template>
  <div>
    <ul v-if="sortedCategories.length" class="search-results">
      <li
        v-for="category in sortedCategories"
        :key="category.id"
      >
        <LabeledContent
          :headline="{
            level: 2,
            text: `${category.name} (${category.results.length})`
          }"
        >
          <DefinitionList class="search-result__item">
            <template
              v-for="({result, resource}) in category.results"
            >
              <DefinitionTerm
                :key="`term-${result.resource_id}`"
                class="search-result__title"
              >
                <nuxt-link v-if="resource.url" :to="resource.url">
                  {{ typeof resource.readableName === 'object' ? resource.readableName[$language] : resource.readableName }}
                </nuxt-link>
                <span v-else>
                  {{ typeof resource.readableName === 'object' ? resource.readableName[$language] : resource.readableName }}
                </span>
              </DefinitionTerm>
              <DefinitionDescription
                :key="`description-${result.resource_id}`"
                class="search-result__text"
              >
                <Wysiwyg>
                  <div v-html="result.text" />
                </Wysiwyg>
              </DefinitionDescription>
            </template>
          </DefinitionList>
        </LabeledContent>
      </li>
    </ul>
    <div v-else-if="term && term.length" class="search-results__empty">
      <Wysiwyg>
        <h3>Unter dem Begriff "{{ term }}" gab es leider keine Suchergebnisse.</h3>
      </Wysiwyg>
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import { Resource } from 'beisheim/models'
import Wysiwyg from 'beisheim/components/elements/wysiwyg'
import DefinitionList from 'beisheim/components/elements/definition-list'
import DefinitionTerm from 'beisheim/components/elements/definition-term'
import DefinitionDescription from 'beisheim/components/elements/definition-description'
import LabeledContent from 'beisheim/components/elements/labeled-content'

export default {
  components: {
    Wysiwyg,
    LabeledContent,
    DefinitionList,
    DefinitionTerm,
    DefinitionDescription
  },
  props: {
    results: {
      type: Array,
      default: () => []
    },
    term: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    sortedResults () {
      return sortBy(this.results, 'search_rank')
    },
    resultsByCategory () {
      return this.sortedResults.reduce((acc, result) => {
        const resource = Resource.query().where('id', result.resource_id).first()
        const cat = result.search_category_labels ? result.search_category_labels : {
          de: 'Unsortiert',
          en: 'Unsorted'
        }
        const category = cat[this.$language]
        const value = { result, resource }
        const current = acc.find(c => c.name === category)

        if (!current) {
          return [...acc, { name: category, results: [value] }]
        }

        return acc.map((c) => {
          if (c.name === current.name) {
            return {
              name: current.name,
              results: [ ...current.results, value ]
            }
          }
          return c
        })
      }, [])
    },
    sortedCategories () {
      return sortBy(this.resultsByCategory, 'name')
    }
  }
}
</script>

<style lang="scss">
  .search-results__empty {
    margin-top: 2rem;
  }
</style>
